/**
 * Where the "Set it up" reminder is pointing (orbit-ui#161).
 *
 * The security page holds passkeys, two-factor, face check-in and the
 * password form, in that order. A button that says "set up face check-in"
 * and lands somebody at the top of that page has handed them a search, not
 * a destination — the card they were sent for is two screens down.
 *
 * Shared so the banner and the card cannot disagree about the name. An
 * anchor nobody matches scrolls nowhere and says nothing about why.
 */
export const FACE_SECTION_ID = 'face-check-in';

/** The security page, aimed at the face card rather than the top of it. */
export const FACE_SECTION_PATH = `/settings/security#${FACE_SECTION_ID}`;
